import * as React from 'react';
import styled from 'styled-components';

const AuthorDateAndSocial = styled.aside`
	display: flex;
	justify-content: space-between;

	@media(${(props) => props.theme.mediumUp}) {
		flex-direction: column;
		justify-content: flex-start;
	}

	&.col-12 {
		padding: 0;
	}

`;

const AuthorDateSocial = ({ children }) => (
	<AuthorDateAndSocial className='col-12 col-md-3'>{children}</AuthorDateAndSocial>
);

export default AuthorDateSocial;
